var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSidebar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.857,
    height: 19.925,
    viewBox: "0 0 19.857 19.925",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#43756a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-133.73 -131.656)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.73 131.656)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.274,0H.726A.728.728,0,0,0,0,.726V8.274A.728.728,0,0,0,.726,9H8.274A.728.728,0,0,0,9,8.274V.726A.728.728,0,0,0,8.274,0ZM7.548,7.548h-6.1v-6.1h6.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.588 131.656)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M154.274,0h-7.548A.728.728,0,0,0,146,.726V8.274a.728.728,0,0,0,.726.726h7.548A.728.728,0,0,0,155,8.274V.726A.728.728,0,0,0,154.274,0Zm-.726,7.548h-6.1v-6.1h6.1Z",
    transform: "translate(-146)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.73 142.581)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.274,146H.726a.728.728,0,0,0-.726.726v7.548A.728.728,0,0,0,.726,155H8.274A.728.728,0,0,0,9,154.274v-7.548A.728.728,0,0,0,8.274,146Zm-.726,7.548h-6.1v-6.1h6.1Z",
    transform: "translate(0 -146)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.588 142.581)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M154.274,146h-7.548a.728.728,0,0,0-.726.726v7.548a.728.728,0,0,0,.726.726h7.548a.728.728,0,0,0,.726-.726v-7.548A.728.728,0,0,0,154.274,146Zm-.726,7.548h-6.1v-6.1h6.1Z",
    transform: "translate(-146 -146)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSidebar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sidebar.db85889c.svg";
export { ForwardRef as ReactComponent };